import type { Control, FieldValues, Path } from "react-hook-form";
import { Controller } from "react-hook-form";

import { RadioGroupCard } from "@/ui";

interface Option {
  label: string;
  value: string;
}

interface ControlledRadioGroupCardProps<TFieldValues extends FieldValues> {
  name: Path<TFieldValues>;
  control: Control<TFieldValues>;
  options: Option[];
  error?: string;
}

export const ControlledRadioGroupCard = <TFieldValues extends FieldValues>({
  name,
  control,
  options,
}: ControlledRadioGroupCardProps<TFieldValues>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <RadioGroupCard.Root value={field.value} onValueChange={field.onChange}>
          <div className="flex gap-4">
            {options.map((option) => (
              <RadioGroupCard.Item
                key={option.label}
                value={option.value}
                id={`${name}${option.value}`}
                error={fieldState.error?.message}
              >
                <RadioGroupCard.ItemLabel htmlFor={`${name}${option.value}`}>
                  {option.label}
                </RadioGroupCard.ItemLabel>
              </RadioGroupCard.Item>
            ))}
          </div>
        </RadioGroupCard.Root>
      )}
    />
  );
};
